export default "__VITE_ASSET__3f3d347e__"